import React from 'react';
import { Box, IconButton } from '@mui/material';
import FilterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import ManageSectionIcon from 'packages/novous_web/src/assets/icons/Custom.svg';
import ThreeDots from 'packages/novous_web/src/assets/icons/new-menu.svg';
import CustomDropDownInput from 'packages/novous_web/src/common/components/customDropDownInput';
import CustomButton from 'packages/novous_web/src/common/components/CustomButton';
import { width } from '@mui/system';

interface Option {
  value: string | number;
  label: string;
  description?: string;
}

interface AnalyticsHeaderProps {
  selectedView: string;
  anchorEl: HTMLElement | null;
  open: boolean;
  menuOptions: Option[]; // <-- change here
  handleMenuOpen: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleMenuClose: (option?: string) => void;
  onOpenFilter: () => void;
  onManageSectionsClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onManageViewsClick?: () => void;
}

const AnalyticsHeader: React.FC<AnalyticsHeaderProps> = ({
  selectedView,
  anchorEl,
  open,
  menuOptions,
  handleMenuOpen,
  handleMenuClose,
  onOpenFilter,
  onManageSectionsClick,
  onManageViewsClick,
}) => {
  return (
    <Box
      className="w-full flex justify-between items-end gap-2"
      sx={{
        '@media (max-width: 768px)': {
          px: 1,
          py: 1,
          gap: 1,
        },
      }}
    >
      <Box className="flex items-center gap-1 w-1/4">
        <CustomDropDownInput
          label=""
          options={menuOptions}
          value={selectedView}
          onChange={(option) => handleMenuClose(option)}
          showDropdownArrow
          customStyles={{
            height: '48px',
            padding: '12px 16px',
            borderRadius: '8px',
            border: '1px solid #E0E0E0',
            backgroundColor: '#FFFFFF',
            gap: '8px',
            opacity: 1,
            typography: {
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: '21px',
              letterSpacing: '0%',
              color: '#080808',
            },
          }}
        />
      </Box>

      <Box className="flex items-center gap-2 mt-2 md:mt-0 w-2/3 justify-end">
        <CustomButton
          buttonText="Filters"
          iconSrc={FilterIcon}
          iconSize={24}
          onClick={onOpenFilter}
          sx={{
            height: { xs: 'auto !important', sm: 'auto !important', md: 'auto !important' },
            flexDirection: 'row-reverse !important',
            gap: 2,
            border: 'none !important',
            outline: 'none !important',
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0%',
            color: (theme) => theme.palette.primary.main,
          }}
        />
        <CustomButton
          buttonText="Manage Sections"
          iconSrc={ManageSectionIcon}
          iconSize={24}
          onClick={onManageViewsClick}
          sx={{
            height: '45px !important',
            flexDirection: 'row-reverse !important',
            gap: '8px',
            opacity: 1,
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '21px',
            letterSpacing: '0%',
            color: '#FFFFFF',
          }}
          variant="contained"
        />
        {/* <IconButton
          aria-label="More"
          size="small"
          onClick={onManageSectionsClick}
          sx={{
            width: '45px',
            height: '45px',
            gap: '8px',
            opacity: 1,
            padding: '10px',
            borderRadius: '8px',
            border: '1px solid #5547DD',
            '&:hover': { backgroundColor: '#FBFBFB' },
          }}
        >
          <Box
            component="img"
            src={ThreeDots}
            alt="More"
            sx={{
              width: '24px',
              height: '24px',
              opacity: 1,
              borderRadius: '4px',
              '& path': {
                fill: '#5547DD',
              },
              filter:
                'brightness(0) saturate(100%) invert(26%) sepia(75%) saturate(2446%) hue-rotate(236deg) brightness(95%) contrast(95%)',
            }}
          />
        </IconButton> */}
      </Box>
    </Box>
  );
};

export default AnalyticsHeader;
